// ReportsTab.js
// Right Report tab — now renders the Portfolio Analytics dashboard.
import React from 'react';
import PortfolioPage from '../Portfolio/PortfolioPage';

const ReportsTab = () => <PortfolioPage />;

export default ReportsTab;
